<div class="d-flex-center">
  <label [for]="name" class="col-sm-3 form-label action">{{fieldLabel}}</label>
  <div
    class="col-sm-9"
    [ngClass]="{ 'has-error': control?.invalid && control?.touched }"
    >
    <input
      disableAutoComplete
      [name]="name"
      [id]="name"
      class="form-control"
      type="text"
      [mention]="actionMention"
      [mentionConfig]="actionMentionConfig"
      [formControl]="control"
      dir="auto"
      />
    <app-error-display 
      [control]="control" 
      [customErrorMessageProvider]="getTooltipData.bind(this)">
    </app-error-display>
  </div>
</div>